/**
 * Ensures only one HTML5 video plays at a time on the current page.
 * When a video starts playing, all other managed videos are paused.
 */
(function () {
  'use strict';

  function isAmbientVideo(video) {
    if (!video || video.tagName !== 'VIDEO') return true;
    if (video.hasAttribute('data-video-ambient')) return true;
    // Hover previews are played by JS on hover/focus (no autoplay attribute).
    if (video.classList && (video.classList.contains('shop-by-need__card-video') || video.classList.contains('support-product-card__hover-video'))) return true;
    // Product hero gallery videos are JS-managed (pause on slide / other video).
    if (video.hasAttribute('data-dph-gallery-video')) return false;
    // Decorative previews (hover cards, hero loops, etc.)
    return video.autoplay && video.muted && video.loop;
  }

  function pauseVideo(video) {
    if (!video || video.paused || typeof video.pause !== 'function') return;
    try {
      video.pause();
    } catch (e) {}
  }

  function pauseOtherVideos(activeVideo) {
    document.querySelectorAll('video').forEach(function (video) {
      if (video === activeVideo || isAmbientVideo(video)) return;
      pauseVideo(video);
    });
  }

  function pauseAllPlayingVideos() {
    document.querySelectorAll('video').forEach(pauseVideo);
  }

  function onVideoPlay(event) {
    var video = event.target;
    if (!video || video.tagName !== 'VIDEO') return;
    if (isAmbientVideo(video)) return;

    pauseOtherVideos(video);
  }

  function onPageHidden() {
    if (document.visibilityState === 'hidden') {
      pauseAllPlayingVideos();
    }
  }

  // Window blur alone is too aggressive (fires on load / chrome focus).
  // Only pause non-gallery videos; tab hide is handled by visibilitychange.
  function onWindowBlur() {
    if (document.visibilityState === 'hidden') {
      pauseAllPlayingVideos();
      return;
    }
    document.querySelectorAll('video').forEach(function (video) {
      if (video.hasAttribute('data-dph-gallery-video')) return;
      pauseVideo(video);
    });
  }

  document.addEventListener('play', onVideoPlay, true);
  document.addEventListener('visibilitychange', onPageHidden);
  window.addEventListener('pagehide', pauseAllPlayingVideos);
  window.addEventListener('blur', onWindowBlur);
})();
